import { render, staticRenderFns } from "./DsoReleasesForm.vue?vue&type=template&id=75a63aef&"
import script from "./DsoReleasesForm.vue?vue&type=script&lang=js&"
export * from "./DsoReleasesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports